import { useState } from 'react';

export default function HeroSection() {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/807ae92a1bb44add6ee21cf8a9dac740.jpg"
          alt="Espacio limpio después de incendio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Content - 60% */}
          <div className="lg:col-span-3">
            <div className="mb-6">
              <span className="text-secondary uppercase text-xs tracking-wider font-sans font-semibold">
                /limpieza-post-incendio
              </span>
            </div>
            
            <h1 className="font-serif font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight break-words">
              Limpieza profesional después de un incendio en Barcelona
            </h1>
            
            <p className="text-white/90 text-base sm:text-lg md:text-xl mb-10 leading-relaxed max-w-2xl">
              Eliminamos hollín, cenizas y olores. Recuperamos espacios seguros para que puedas volver a casa. Coordinación con seguros y peritos.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <a
                href="tel:+34690220944"
                className="bg-primary text-white px-6 sm:px-8 py-4 rounded-full font-sans font-semibold text-sm sm:text-base hover:bg-opacity-90 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-phone-line mr-2 text-xl"></i>
                Llamar Ahora
              </a>
              <a
                href="https://wa.me/34690220944"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-accent text-white px-6 sm:px-8 py-4 rounded-full font-sans font-semibold text-sm sm:text-base hover:bg-opacity-90 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                WhatsApp
              </a>
              <button
                onClick={() => setShowModal(true)}
                className="bg-transparent border-2 border-secondary text-white px-6 sm:px-8 py-4 rounded-full font-sans font-semibold text-sm sm:text-base hover:bg-secondary hover:border-secondary transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-image-line mr-2 text-xl"></i>
                Enviar Fotos
              </button>
            </div>
          </div>

          {/* Right Card - 40% */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg p-6 sm:p-8 shadow-lg">
              <h3 className="font-serif font-bold text-xl sm:text-2xl text-primary mb-6">
                Equipamiento Profesional
              </h3>
              <div className="grid grid-cols-2 gap-4 sm:gap-6">
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-shield-check-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">EPIs Certificados</p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-contrast-drop-2-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">Aspirado HEPA</p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-drop-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">Neutralización Olores</p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-file-list-3-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">Documentación Seguros</p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-checkbox-circle-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">Checklist Final</p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 flex items-center justify-center bg-bg rounded-full">
                    <i className="ri-time-line text-2xl sm:text-3xl text-secondary"></i>
                  </div>
                  <p className="text-xs sm:text-sm text-textLight">Respuesta Rápida</p>
                </div>
              </div>
              <p className="text-xs text-textLight text-center mt-6">
                Equipamiento profesional · Coordinación con peritos
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Photo Upload Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6 mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-serif font-bold text-xl text-primary">Enviar Fotos</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-textLight hover:text-primary cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <p className="text-textLight mb-4">
              Envíanos fotos por WhatsApp para una evaluación rápida:
            </p>
            <a
              href="https://wa.me/34690220944"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-[#25D366] text-white px-6 py-3 rounded-full font-sans font-semibold text-center hover:bg-opacity-90 transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Abrir WhatsApp
            </a>
          </div>
        </div>
      )}
    </section>
  );
}